import { useEffect } from "react";
import { Browser } from "@capacitor/browser";
import { mobile } from "../utils/platformUtils";

//hook to open external links in the app whit capacitor browser if is mobile
export const useExternalLinks = () => {
  useEffect(() => {
    //handle click event to open external links in the app whit capacitor browser
    const handleClick = async (event: MouseEvent) => {
      //get the target element
      const target = event.target as HTMLElement;
      //get the closest anchor element
      const anchor = target.closest("a");

      //if the anchor element is not null, and the href is not a javascript link, and the href does not include the window location origin, then open the link in the app whit capacitor browser
      if (anchor && anchor.href && !anchor.href.startsWith("javascript:") && !anchor.href.includes(window.location.origin)) {
        //prevent the default behavior of the anchor element
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (mobile) {
          try {
            await Browser.open({
              url: anchor.href,
              windowName: "_self",
              presentationStyle: "popover",
            });
          } catch (error) {
            console.error("Error opening link in Capacitor Browser:", error);
          }
        } else {
          // For web, open in new tab
          window.open(anchor.href, "_blank", "noopener,noreferrer");
        }
      }
    };

    //add the event listener to the document
    document.addEventListener("click", handleClick, { capture: true, passive: false });

    return () => {
      document.removeEventListener("click", handleClick, { capture: true });
    };
  }, []);
};
